<template>
  <b-overlay
      id="overlay-heartbeat"
      show
      :variant="overlayVariant"
      :opacity="overlayOpacity"
      :blur="overlayBlur"
      :show="showOverlay"
      :rounded="overlayRounded"
  >
  <div v-if="loading">
    <b-spinner variant="warning" class="app-loader" label="Spinning" />
  </div>
  <div v-else>
    <div class="fhbapp-main" :class="{ 'grid-template': templateClass }">
      <Topbar @showHelpSidebar="showHelpModal" style="width: 100%" />
      <div style="height: 60px; "></div>
      <transition mode="out-in">
        <router-view
            @showHelp="showHelpModal"
            @show-overlay="handleOverlay"
            style="margin-top:0px;"
        />
      </transition>
    </div>
    <transition name="slide-fade">
      <guide-help :show="showHelp" @closeHelp="closeHelpModal" />
    </transition>
  </div>
    <template #overlay>
      <radial-progress-bar :diameter="125"
                           :completed-steps="overlayCompletedSteps"
                           :total-steps="overlayTotalSteps">
        <b-img
            v-if="overlayImgURL"
            v-bind="overlayMainProps"
            :src="overlayImgURL"
            rounded="circle"
            alt="Circle image"
        />
      </radial-progress-bar>
    </template>
  </b-overlay>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import Sidebar from "@/components/common/sidebar";
import Topbar from "@/components/common/topbar";
import guideHelp from "@/components/jab/guides/guideHelp";
import RadialProgressBar from 'vue-radial-progress'
export default {
  name: "App_FHB",
  components: {
    Sidebar,
    Topbar,
    guideHelp,
    RadialProgressBar
  },
  created() {
    let that = this;
    window.onload = function(e) {
      // that.sidebarResponsive();
      window.addEventListener("resize", () => {
        that.sidebarResponsive();
      });
    };
    if (this.user) {
      this.loading = false;
    }
  },
  computed: {
    ...mapState(["settings"]),
    ...mapGetters({
      user: "user/user"
    })
  },
  watch: {
    user(auth) {
      if (auth) {
        this.loading = false;
        // this.sidebarResponsive();
      }
    }
  },
  methods: {
    showHelpModal() {
      debugger;
      this.showHelp = true;
    },
    closeHelpModal() {
      this.showHelp = false;
    },
    handleOverlay({show, variant, imgURL, completedSteps, totalSteps}){
      debugger;
      if (show) {
        this.overlayVariant = variant;
        this.overlayImgURL = imgURL;
        this.overlayCompletedSteps = completedSteps;
        this.overlayTotalSteps = totalSteps;
        this.showOverlay = true;
      } else{
        this.showOverlay = false;
      }
    },
    activateSidebar() {
      document.querySelector(".top-bar").classList.remove("full");
      this.templateClass = true;
      this.showSidebar = true;
    },
    disbaleSidebar() {
      document.querySelector(".top-bar").classList.add("full");
      this.showSidebar = false;
      this.templateClass = false;
    },
    sidebarResponsive() {
      if (window.innerWidth < 1440) {
        this.disbaleSidebar();
      } else {
        this.activateSidebar();
      }
    }
  },
  data() {
    return {
      showHelp: false,
      showSidebar: true,
      templateClass: true,
      loading: true,
      /**** HEARTBEAT OVERLAY */
      overlayVariant: 'warning',
      overlayOpacity: 0.45,
      overlayBlur: '2px',
      showOverlay: false,
      overlayRounded:'sm',
      overlayCompletedSteps: 5,
      overlayTotalSteps: 10,
      overlayImgURL: null,
      overlayMainProps: {
        blank: false,
        blankColor: "#777",
        width: 100,
        height: 100,
        class: "m1"
      }
    };
  }
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Nunito:wght@200;300;400;600;700;800&display=swap");
body {
  overflow-x: hidden;
}
svg {
  overflow: hidden;
  vertical-align: middle !important;
}
* {
  font-family: "Nunito", sans-serif;
}
.app {
  overflow-x: hidden;
}

.fhbapp-main {
  a {
    &:hover {
      box-shadow: none;
    }
  }
}

.grid-template {
  grid-template-columns: 234px 1fr;
}
*:focus {
  outline: none !important;
}
.btn-outline {
  padding: 10px 15px;
  border: 1px solid var(--theme-color);
  font-family: "Nunito", sans-serif;
  font-size: 16px;
  background-color: #fff;
  border-radius: 10px;
  font-weight: 600;
  color: var(--theme-color);
}
.btn-fill {
  padding: 10px 15px;
  border: 1px solid var(--theme-color);
  font-family: "Nunito", sans-serif;
  font-size: 16px;
  background-color: var(--theme-color);
  color: #fff;
  border-radius: 10px;
  font-weight: normal;
}
.btn-outline-primary {
  border-color: var(--theme-color) !important;
}
.btn-primary {
  background-color: var(--theme-color) !important;
}
.btn-primary:hover,
.btn-primary:active,
.btn-primary:focus {
  background-color: #496cd4 !important;
}
.top-bar {
  .actions > .btn-primary,
  .actions > .btn-outline-primary {
    border-radius: 10px;
  }
  .notifications-panel {
    .btn {
      border-radius: 0.2rem;
    }
  }
}
.btn-outline-primary:hover {
  background-color: var(--theme-color);
  svg {
    path {
      fill: #fff !important;
    }
    fill: #fff !important;
  }
}
.right-container-layout {
  position: relative;
}
@media (max-width: 1440px) {
  .overlay-sidebar {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0);
    z-index: 7;
  }
}
button:focus {
  outline: none;
}

.tracked,
.deck,
.stationed {
  /* width */
  ::-webkit-scrollbar {
    width: 6px;
    height: 8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #474d52;
    border-radius: 10px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}

.slide-fade-enter-active {
  transition: all 0.2s ease;
}
.slide-fade-leave-active {
  transition: all 0.2s ease-in-out;
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(20px);
  opacity: 0;
}

.slide-fade-left-enter-active {
  transition: all 0.4s ease;
}
.slide-fade-left-leave-active {
  transition: all 0s ease-in-out;
}
.slide-fade-left-enter
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(-100%);
  opacity: 0;
}
.slide-fade-left-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.list-item {
  display: inline-block;
  margin-right: 10px;
}

// fixes slight flickering after moving
.list-leave-active {
  display: none !important;
}

.bg-sidebar {
  height: 100%;
  width: 60px;
}
@media (min-width: 1441px) {
  .bg-sidebar {
    display: none;
  }
}
.app-loader {
  position: absolute;
  left: 50%;
  top: 50%;
}
</style>
